import { render, staticRenderFns } from "./RegistrationBenefits.vue?vue&type=template&id=fbdc24e6&"
import script from "./RegistrationBenefits.js?vue&type=script&lang=js&"
export * from "./RegistrationBenefits.js?vue&type=script&lang=js&"
import style0 from "./RegistrationBenefits.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports